// app/config/msalConfig.ts
import { Configuration, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { AppConfig } from '../../config/loadConfigJson';

export let msalConfig: Configuration;
let _msalInstance: PublicClientApplication | null = null;

export let loginRequest: { scopes: string[] };
export let protectedResources: Map<string, Array<string>>;

export const initializeMsalConfig = (appConfig: AppConfig) => {
  if (!appConfig) throw new Error("App configuration is not loaded.");

  msalConfig = {
    auth: {
      clientId: appConfig.cliendId, // (typo in jouw config key blijft zoals je het gebruikt)
      authority: `https://login.microsoftonline.com/${appConfig.tenantId}`,
      redirectUri: appConfig.redirectUrl,
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: true,
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          // if (!containsPii) console.log(message);
        },
        logLevel: LogLevel.Info,
      },
    },
  };

  // Instance (maak maar 1x)
  if (!_msalInstance) {
    _msalInstance = new PublicClientApplication(msalConfig);
  }

  loginRequest = {
    // NB: in veel setups is dit NIET de juiste scope; maar ik laat jouw intentie intact.
    // Beter is vaak: scopes: ["api://<clientId>/access_as_user"] of "User.Read" voor Graph.
    scopes: [`${appConfig.cliendId}/access_as_user`],
  };

  protectedResources = new Map<string, Array<string>>([
    ["https://graph.microsoft.com/v1.0/me", ["User.Read"]],
    [appConfig.portalUrl, [`${appConfig.cliendId}/access_as_user`]],
  ]);
};

export const getMsalConfig = (): Configuration => {
  if (!msalConfig) throw new Error("MSAL config is not initialized. Call initializeMsalConfig first.");
  return msalConfig;
};

export const getMsalInstance = (): PublicClientApplication => {
  if (!_msalInstance) throw new Error("MSAL instance is not initialized. Call initializeMsalConfig first.");
  return _msalInstance;
};
